import { Helmet } from "react-helmet-async";

export default function Seo({ title, description, path = "/", image, schema }) {
  const fullTitle = title
    ? `${title} | ISGS Asbestos Consulting`
    : "ISGS Asbestos Consulting — Asbestos Inspections, Air Monitoring & Risk Assessments NSW";
  const desc =
    description ||
    "ISGS Asbestos Consulting — NSW-based experts in asbestos inspections, sampling, risk assessments, air monitoring, clearance certificates and project management. NATA-accredited. 24/7 emergency response.";
  const url = `https://www.isgsasbestos.com.au${path}`;
  const img = image || "https://customer-assets.emergentagent.com/job_draft-preview-11/artifacts/dzt6eboi_ISGS_Logo.png";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
}
